var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid-resize",class:{ 'grid-resize--active': _vm.resizing },on:{"mousedown":_vm.startResize}})}
var staticRenderFns = []

export { render, staticRenderFns }